// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"4ba8e49d","239":"389b3eb2","453":"b2bb9cbd","648":"a4079a13","732":"b8c870f8","977":"b148af08"}[chunkId] + ".chunk.js";
};